module.exports = __webpack_public_path__ + "img/mobile-menu-continue.590d9850.webp";